import React from 'react';
import cx from 'classnames';
import { forTemplate } from 'app/common/lib/util/i18n';
import { Spinner } from 'app/src/components/Spinner';
import { useUpdateCardCoverMutation } from '@trello/graphql/generated';
import styles from './SearchResultImageButton.less';
import { track } from '@trello/analytics';
import { unsplashClient } from '@trello/unsplash';

const format = forTemplate('card_cover_chooser');
const PhotoAttributionComponent = require('app/scripts/views/board-create/photo-attribution-component');

export interface SearchResultImageButtonProps {
  cardId: string;
  index: number;
  urls: { thumb: string; raw: string };
  user: { name: string; links: { html: string } };
  links: { download_location: string };
  onSetCover: () => void;
  onSetCoverFailed: () => void;
}

export const SearchResultImageButton: React.FunctionComponent<SearchResultImageButtonProps> = ({
  cardId,
  index,
  urls,
  links,
  user,
  onSetCover,
  onSetCoverFailed,
}) => {
  const [updateCardCover, { loading }] = useUpdateCardCoverMutation({
    onError: onSetCoverFailed,
    onCompleted: () => {
      onSetCover();
      track('Card Cover Chooser', 'Choose Unsplash Search Result');
    },
  });

  const setCover = async (cover: { url: string }) => {
    await updateCardCover({
      variables: {
        cardId,
        cover,
      },
    });

    // Send Unsplash an analytics event
    unsplashClient.trackDownload({ links });
  };

  const coverButtonOverlay = () => {
    if (loading) {
      return (
        <div className={styles.upload}>
          <Spinner inline modLeft small text={format('uploading-ellipsis')} />
        </div>
      );
    } else {
      return <PhotoAttributionComponent user={user} />;
    }
  };

  return (
    <div key={index} className={styles.backgroundGridItem}>
      <button
        className={cx('button', styles.coverTilesItem)}
        style={{
          backgroundImage: `url('${urls.thumb}')`,
        }}
        onClick={() =>
          setCover({
            url: unsplashClient.appendImageParameters(urls.raw),
          })
        }
      >
        {coverButtonOverlay()}
      </button>
    </div>
  );
};
